import { usePermissionService } from 'hooks/iam/permission';
import { useRoleService } from 'hooks/iam/role';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const PermissionsContext = React.createContext({
  is_loading: true,
  permissions: {}
});

export const PermissionsProvider = ({ children }) => {
  const { fetchPermissions } = usePermissionService();
  const { fetchRole } = useRoleService();

  const { tenant_id, memberships } = useSelector((store) => store.user_data);

  const [is_loading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const active_membership = (memberships || []).find(
      (membership) => Number(membership.tenant_id) === Number(tenant_id)
    );
    if (!active_membership) return;

    const { role_id } = active_membership;
    const is_super_admin = Number(role_id) === 1;
    setIsLoading(true);
    Promise.all([fetchPermissions(), fetchRole(role_id)])
      .then(([{ permissions: all_permissions }, { role }]) => {
        const permissions = is_super_admin ? all_permissions : role.permissions;
        const parsed_permissions = {};
        (permissions || []).forEach((permission) => {
          const { resource, actions } = permission;
          (actions || []).forEach((action) => {
            const action_name = is_super_admin ? action : action.name;
            parsed_permissions[`${resource}:${action_name}`] = is_super_admin
              ? true
              : action.is_permitted;
          });
        });
        setPermissions(parsed_permissions);
      })
      .finally(() => setIsLoading(false));
  }, [tenant_id]);

  const value = {
    is_loading,
    permissions
  };
  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>;
};
